import { combineReducers } from 'redux'

import resultados from './detalhesContrato'
import gestores from './gestoresContrato'
import eventos from './eventosContrato'
import aditivos from './aditivosContrato'
import itens from './itensContratados'
import empenhos from './empenhosContrato'

export default combineReducers({ resultados, gestores, eventos, aditivos, itens, empenhos })
